<ul class="breadcrumb" *ngIf="dialogRef == null">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li *ngIf="task.organization_id != null && task.organization_id != 0"><i class="pi pi-angle-right"></i></li>
    <li *ngIf="task.organization_id != null && task.organization_id != 0"><a [routerLink]="['/organizations']">Organizaciones</a></li>
    <li *ngIf="task.organization_id != null && task.organization_id != 0"><i class="pi pi-angle-right"></i></li>
    <li *ngIf="task.organization_id != null && task.organization_id != 0"><a [routerLink]="['/organizations', 0, task.organization_id]">{{task.organization?.name}}</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/tasks']">Actividades</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li [hidden]="task.id==null"><a [routerLink]="['/tasks',task.organization_id, task.id]">{{task.subject}}</a></li>
</ul>
<div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between p-mb-0 p-mb-lg-4">
  <div class="">
    <p-button *ngIf="showPrevButton" icon="pi pi-angle-left" (onClick)="loadPrevNext(1)"
              styleClass="p-button-info p-button-outlined" (mouseenter)="onMouseEnterButton('prev')"
              (mouseleave)="onMouseLeaveButton()"></p-button>
  </div>
    <div class="">
        <ul class="step-line">
            <li (click)="status_selected(status.id)" *ngFor="let status of tasks_status"
                [ngClass]="task.task_status_id == status.id?'bg-'+status.css_class:''">
                {{status.name}}<span class="separator"></span>
            </li>
        </ul>
    </div>
    <div class="">
      <p-button *ngIf="showNextButton" icon="pi pi-angle-right" (click)="loadPrevNext(0)"
                styleClass="p-button-info p-button-outlined " (mouseenter)="onMouseEnterButton('next')"
                (mouseleave)="onMouseLeaveButton()"></p-button>
    </div>
</div>
<app-view #view [code]="'tasks.edit'" [model]="task" [config]="viewConfig" (onEvent)="onEvent($event)"></app-view>
<div [ngStyle]="{'top':yPos,'left':xPos}" class="tooltip-div" *ngIf="tooltip_info.show && false">
    <span class="tooltiptext">
        <b>{{tooltip_info.mode}}</b><br />
        <small>
            Asunto: {{tooltip_info.subject}} <br />
            Empresa: {{tooltip_info.organization}} <br />
            Responsable: {{tooltip_info.responsible}} <br />
            Contacto: {{tooltip_info.contact}} <br />
            Últ. acción: {{tooltip_info.last_action_date | date: 'dd/MM/yyyy hh:mm'}} <br /></small>
    </span>
</div>
